import { Chip, makeStyles } from "@material-ui/core";
import React, { Fragment } from "react";
import styles from "../../../styles/global-styles";
import StyleTableRow from "../../../styles/styleTableRow";
import StyledTableCell from "../../../styles/tableCell";
import { customDate } from "../../../_utils/utils";

const useStyles = makeStyles((theme) => ({
  chip: styles.chip,
  secondaryChip: styles.secondaryChip,
}));

const DistributionBodyDashboard = ({ distributionArray }) => {
  const classes = useStyles();

  return (
    <Fragment>
      {distributionArray.length &&
        distributionArray.map((row, i) => (
          <StyleTableRow key={i}>
            <StyledTableCell align="left">
              her {row.product?.product_type?.name}
            </StyledTableCell>
            <StyledTableCell align="left">
              {row.product?.movile?.brand} {row.product?.movile?.model}
            </StyledTableCell>
            <StyledTableCell align="center">
              {row.personDeliver?.name || "Sin definir"}
            </StyledTableCell>
            <StyledTableCell align="center">
              {row.personReceives?.name || "Sin definir"}
            </StyledTableCell>

            <StyledTableCell align="center">
              <Chip
                label={row.status_distribution?.status || "Sin definir"}
                className={classes.chip}
              />
            </StyledTableCell>
            <StyledTableCell align="center">
              {row.originSite ? row.originSite.name : "Almacén"}
            </StyledTableCell>
            <StyledTableCell align="center">
              {row.originDestination
                ? row.originDestination.name
                : "Sin definir"}
            </StyledTableCell>

            <StyledTableCell align="center">
              {customDate(row.updatedAt)}
            </StyledTableCell>
          </StyleTableRow>
        ))}
    </Fragment>
  );
};

export default DistributionBodyDashboard;
